import script from "./treeNav.vue?vue&type=script&lang=tsx&setup=true"
export * from "./treeNav.vue?vue&type=script&lang=tsx&setup=true"

import "./treeNav.vue?vue&type=style&index=0&id=f72d3650&lang=less&scoped=true"

import exportComponent from "/opt/teams-app/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.74.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f72d3650"]])

export default __exports__